import * as yup from 'yup';

export const contraenteSchema = yup.object({
  gender: yup.string().oneOf(['M', 'F', 'G']).required(),
  business_name: yup.string().nullable().when('gender', {
    is: 'G',
    then: () => yup.string().required('Inserisci la ragione sociale!'),
  }),
  vat_number: yup.string().nullable().when('gender', {
    is: 'G',
    then: () => yup.string().max(11, 'Massimo 11 caratteri')
      .matches(/^[0-9]*$/, 'Solo numeri sono ammessi!')
      .required('Inserisci la partita IVA!'),
  }),
  company_type: yup.string().nullable().when('gender', {
    is: 'G',
    then: () => yup.string().required('Seleziona la tipologia azienda!'),
  }),
  fiscal_code: yup.string().nullable().when('gender', {
    is: (g) => g !== 'G',
    then: () => yup.string().length(16, 'Il codice fiscale deve avere 16 caratteri')
      .required('Inserisci il codice fiscale!'),
  }),
  name: yup.string().nullable().when('gender', {
    is: (g) => g !== 'G',
    then: () => yup.string().required('Inserisci il nome!'),
  }),
  surname: yup.string().nullable().when('gender', {
    is: (g) => g !== 'G',
    then: () => yup.string().required('Inserisci il cognome!'),
  }),
  address: yup.string().required("Inserisci l'indirizzo!"),
  /* Required like every other product (RcVehicle.validations.js:115,
     CondominioFormFlow.validation.js:95 — same pattern). Without a rule here the field could
     never be invalid, and isValid() returns true for any touched field with no error — so the
     address autocomplete, which writes house_number with shouldTouch even when Google returns
     no street number, painted an empty box green as though it had been filled correctly. */
  house_number: yup.string().required('Il campo è obbligatorio.')
    .matches(/^[1-9]\d*([a-zA-Z]|\/(\d+[a-zA-Z]?|[a-zA-Z]+))?$/, 'Il numero deve essere maggiore di 0.'),
  postal_code: yup.string().matches(/^[0-9]{5}$/, 'Il CAP deve avere 5 cifre').required('Inserisci il CAP!'),
  residence_commune_code: yup.string().required('Seleziona il comune!'),
  residence_province_code: yup.string().required('Seleziona la provincia!'),
});

export const contattiSchema = yup.object({
  email: yup.string().email('Email non valida').required("Inserisci l'email!"),
  pec: yup.string().email('PEC non valida').required('Inserisci la PEC!'),
  // Same rule the rest of the platform uses (RcVehicle.validations.js:40,
  // CondominioFormFlow.validation.js:62): an Italian mobile — leading 3, then 8-9 digits.
  // Without it "23" passed as a phone number.
  phone: yup.string().required('Inserisci il telefono!')
    .matches(/^[3]{1}[0-9]{8,9}$/, 'Il numero non è corretto'),
  // Not sent anywhere: it only decides whether the Referente Aziendale fields are on screen.
  // Declared here so trigger() over this step's field list does not choke on an unknown key.
  has_contact_person: yup.boolean(),
  contact_name: yup.string().nullable(),
  // Optional, but held to the same shape once something is typed — excludeEmptyString keeps
  // an untouched field from failing.
  contact_phone: yup.string().nullable()
    .matches(/^[3]{1}[0-9]{8,9}$/, { message: 'Il numero non è corretto', excludeEmptyString: true }),
  contact_email: yup.string().email('Email non valida').nullable(),
});

export const beneficiarioSchema = yup.object({
  beneficiary_business_name: yup.string().required('Inserisci la ragione sociale del beneficiario!'),
  beneficiary_address: yup.string().nullable(),
  beneficiary_house_number: yup.string().nullable(),
  beneficiary_locality: yup.string().nullable(),
  beneficiary_province: yup.string().nullable()
    .matches(/^$|^[A-Za-z]{2}$/, 'La provincia deve avere 2 lettere (es. NA)'),
  beneficiary_postal_code: yup.string().nullable()
    .matches(/^$|^[0-9]{5}$/, 'Il CAP deve avere 5 cifre'),
  beneficiary_vat_or_fiscal_code: yup.string().nullable(),
  beneficiary_pec: yup.string().email('PEC non valida').nullable(),
});

export const garanziaSchema = yup.object({
  effective_date: yup.string().required('Inserisci la data di effetto!'),
  expiry_date: yup.string().required('Inserisci la data di scadenza!')
    .test(
      'after-effect',
      'La scadenza deve essere successiva alla data di effetto',
      function isAfterEffectiveDate(value) {
        const { effective_date: start } = this.parent;
        if (!start || !value) return true;
        return new Date(value) > new Date(start);
      },
    ),
  guaranteed_amount: yup.number()
    .typeError('Inserisci un importo valido')
    .min(1, "L'importo deve essere maggiore di zero")
    .required('Inserisci la somma garantita!'),
  description: yup.string().nullable(),
  notes: yup.string().nullable(),
});

export const cauzioniDefaultValues = {
  gender: 'G',
  business_name: '',
  vat_number: '',
  company_type: '',
  fiscal_code: '',
  name: '',
  surname: '',
  date_of_birth: '',
  address: '',
  house_number: '',
  postal_code: '',
  residence_commune_code: '',
  residence_province_code: '',
  email: '',
  pec: '',
  phone: '',
  has_contact_person: false,
  contact_name: '',
  contact_phone: '',
  contact_email: '',
  active_customer_id: null,
  beneficiary_business_name: '',
  beneficiary_address: '',
  beneficiary_house_number: '',
  beneficiary_locality: '',
  beneficiary_province: '',
  beneficiary_postal_code: '',
  beneficiary_vat_or_fiscal_code: '',
  beneficiary_pec: '',
  effective_date: '',
  expiry_date: '',
  guaranteed_amount: '',
  description: '',
  notes: '',
  extra_data: {},
};
